import gql from 'graphql-tag';
import { CatalogItemCardFragment } from '../fragments/fragments.cartEndpoint';

const PromotionsQuery = {
  getList: gql`
    query findPromotionsAll($page: Int, $setOrder: String, $setLimit: Int) {
      findPromotionsAll(page: $page, setOrder: $setOrder, setLimit: $setLimit) {
        title
        id
        identify
        identifyIdURI
        date
        date_end
        bannersItem {
          catalogItems {
            id
            title
            oldPrice
            price
            discounPriceField
            discounPriceField2
            currentPriceField
            currentPriceField2
            oldPriceField
            oldPriceField2
            priceBlockWeightPrice
            specialPriceData {
              price1Kg
              price
              amount
            }

            measureItem {
              weight
              symbol
            }
          }
          fileItem {
            cacheItem {
              filePath
            }
          }
        }
      }
    }
  `,
  getCount: gql`
    query countPromotionsItems {
      countPromotionsItems
    }
  `,

  getPromotion: gql`
    query findPromotionByIdTemp(
      $id: Int
      $identify: String
      $setLimit: Int
      $page: Int
      $type: String
    ) {
      findPromotionByIdTemp(
        id: $id
        identify: $identify
        setLimit: $setLimit
        page: $page
        type: $type
      ) {
        rubricMenuTree {
          id
          title
          shortTitle
          short_title
          identify
        }
        promotion {
          sTime
          isAvaliable
          title
          id
          identify
          date
          date_end
          attachmentsItem {
            tempFullFilePath
          }
          promotionItems {
            catalogItem {
              ...CatalogItemCardFragment
            }
          }

          bannersItem {
            fileItem {
              cacheItem {
                filePath
              }
            }
          }

          articlesList {
            id
            title
            attachmentsStretchItem {
              tempFullFilePath
            }
            seo_title
            rating
            commentsCount
            attachmentsItem {
              cacheItem {
                filePath
              }
            }
          }
          recipesList {
            id
            isFavorite
            title
            rating
            author
            comments_number
            # text
            date
            identifyIdURI
            recipes_difficult #  иконка с шапкой повара. от 1-го до 5
            slozhnostItem {
              id
              title
            }
            cooking_time # время приготовления
            rating # если 0, то "не оценен" https://www.delikateska.ru/recipes/1775
            serving # порции
            bludoItem {
              id
              title
            }
            attachmentsItem {
              cacheItem {
                filePath # путь карлито
              }
            }
          }
        }
        totalCount
      }
    }
    ${CatalogItemCardFragment}
  `
};

export default PromotionsQuery;
